/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import classes from "./overview.module.scss";
import { useAuth0 } from "@auth0/auth0-react";
import { CloseSvg, ErrorSvg, SucessSvg, WarningSvg } from "../../constants/resources";
import { useNavigate } from "react-router-dom";
import { HandleLogin } from "../../atom/utilities/function";


const SuccessPage = (props: any) => {
    const { successEmail, setModal, buliddata } = props;
    const { isAuthenticated, loginWithRedirect, logout } = useAuth0()
    const navigate = useNavigate()



    useEffect(() => {
        setTimeout(() => {
            if (buliddata?.type === 'Proposal')
                window.location.reload()
        }, 10000);

    }, [])
    const redirectFun = (path: string) => {


        if (isAuthenticated)
            navigate(path)
        else {
            navigate(path)
            HandleLogin(loginWithRedirect, logout, isAuthenticated)
        }
    }


    return (
        <div className={classes.SuccessPage}>
            {
                successEmail === 'Success' || successEmail === 'Error' || successEmail === 'notLogged' || successEmail === 'failed' ?
                    <div className={classes.ModalContent}>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: 'flex-end' }}>
                            <div style={{ cursor: 'pointer' }} onClick={() => setModal(false)}> <CloseSvg /></div>
                        </div>
                        <div className={classes.ScrollContainer}>
                            {successEmail === 'Error' || successEmail === 'notLogged' || successEmail === 'failed' ?
                                <ErrorSvg /> : <SucessSvg />}
                            <p className={classes.head}>{successEmail === 'Error' ? 'Error' : successEmail === 'notLogged' ? 'You are not logged' : successEmail === 'failed' ? 'Network error' : 'Congratulations !'}</p>
                            <p>{successEmail === 'Error' ? 'please try again later' : successEmail === 'notLogged' ? 'please login to submiy your itinearary or proceed to cart' : successEmail === 'failed' ? 'please try after some times' : 'You Have Successfully Submitted the Proposal.Agent will contact you Shortly'}</p>
                            {successEmail === 'notLogged' && <button onClick={() => redirectFun('/viewer/')} className={classes.checkoutbutton}>Log In</button>}
                            {successEmail === 'Success' ? <p> Thank You</p> : null}
                        </div>
                    </div>
                    : successEmail === 'misMatch' ? <div className={classes.ErrorModal}>
                        <div className={classes.ModalContent}>
                            <div className={classes.ScrollContainer}>
                                <p> <WarningSvg />You are trying to access someones profile.</p>
                                <button onClick={() => redirectFun('/viewer/')} className={classes.checkoutbutton}>Go to Profile</button>
                            </div>
                        </div>
                    </div> : <div className={classes.Loader}><div></div><div></div><div></div><div></div></div>}
        </div>

    )
}



export default SuccessPage